import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { PushDevicesState, PushDevicesFilter } from './types';

export const actions: ActionTree<PushDevicesState, RootState> = {
    async getPushDevices({ commit }, params: PushDevicesFilter) {
        commit('setLoading', true);
        try {
            const response = await axios.get('/acapi/push/devices', { params });
            commit('setDevices', response.data?.devices);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async getPushDevicesItem({ commit }, id: number) {
        commit('setLoading', true);
        try {
            const { data } = await axios.get(`/acapi/push/devices/${id}`);
            commit('setDeviceItem', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async deletePushDevice({ commit, dispatch }, id: number) {
        commit('setLoading', true);
        try {
            const response = await axios.delete(`/acapi/push/devices/${id}`);
            const filter = JSON.parse(sessionStorage.getItem('PushDeviceFilter') || '');
            await dispatch('getPushDevices', filter);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async deletePushDevices({ commit, dispatch }, data: { ids: number[], filter: PushDevicesFilter }) {
        commit('setLoading', true);
        try {
            const response = await axios.delete('/acapi/push/devices', { data: { ids: data.ids } });
            await dispatch('getPushDevices', data.filter);
            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async getPushMappsVersions({ commit }, params: { app_id: number }) {
        commit('setLoading', true);
        try {
            const { data } = await axios.get('/acapi/push/mapps/versions', { params });
            commit('setMappsVersions', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async getPushSdkVersions({ commit }) {
        commit('setLoading', true);
        try {
            const { data } = await axios.get('/acapi/push/sdk/versions');
            commit('setSdkVersions', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    },
    async getPushOsVersions({ commit }, params: { os_filter: string }) {
        commit('setLoading', true);
        try {
            const { data } = await axios.get('/acapi/push/os/versions', { params });
            commit('setOsVersions', data);
            return data;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    }
};
